/** The timeline's clock, unchanged from before the second build round: date and time, short. */
export const dateTime = new Intl.DateTimeFormat("sv-SE", { dateStyle: "short", timeStyle: "short" });
